module.exports = __webpack_public_path__ + "img/icon-24-ic-link.ef045cd1.svg";